import { createSlice } from "@reduxjs/toolkit";

// ----------------------------------------------------------------------

const initialState = {
    showBalance: false,
    showTaskPopover: false,
    showNotificationPopover: false,
    showAccountPopover: false,
    //
    shipmentTab: "shipment",
    orderTab: "awaiting",
    quickRateTab: "domestic",
    accountTab: "profile",
    addressTab: "ship_from",
    integrationTab: "stores",
    automationTab: "packages",
    brandingTab: "company"
};

const slice = createSlice({
    name: "other",
    initialState,
    reducers: {
        // UPDATE TASK POPOVER
        updateDisplayTaskPopover(state, action) {
            state.showTaskPopover = action.payload;
        },

        // UPDATE SHIPMENT TAB
        updateShipmentTab(state, action) {
            state.shipmentTab = action.payload;
        },

        // UPDATE ORDER TAB
        updateOrderTab(state, action) {
            state.orderTab = action.payload;
        },

        // UPDATE QUICK RATE TAB
        updateQuickRateTab(state, action) {
            state.quickRateTab = action.payload;
        },

        // UPDATE ACCOUNT TAB
        updateAccountTab(state, action) {
            state.accountTab = action.payload;
        },

        // UPDATE ADDRESS TAB
        updateAddressTab(state, action) {
            state.addressTab = action.payload;
        },

        // UPDATE INTEGRATION TAB
        updateIntegrationTab(state, action) {
            state.integrationTab = action.payload;
        },

        // UPDATE AUTOMATION TAB
        updateAutomationTab(state, action) {
            state.automationTab = action.payload;
        },

        // UPDATE BRANDING TAB
        updateBrandingTab(state, action) {
            state.brandingTab = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// Actions
export const {
    updateDisplayTaskPopover,
    updateShipmentTab, updateOrderTab, updateQuickRateTab,
    updateAccountTab, updateAddressTab, updateIntegrationTab, updateAutomationTab, updateBrandingTab
} = slice.actions;

// ----------------------------------------------------------------------
